const navToggle = document.querySelector('.nav-main-toggle');
const navMain = document.querySelector('.nav-main');
const mainContent = document.querySelector('main');
const navClose = document.querySelector('.nav-main__menu__close');

function openMainNav() {
    if (!navMain || !navToggle) return;

    navMain.classList.add('nav-open');
    navToggle.classList.add('nav-open');
    if (mainContent) {
        mainContent.classList.add('nav-open');
    }
}

function closeMainNav() {
    if (!navMain || !navToggle) return;

    navMain.classList.remove('nav-open');
    navToggle.classList.remove('nav-open');
    if (mainContent) {
        mainContent.classList.remove('nav-open');
    }
}

if (navToggle && navMain) {
    navToggle.addEventListener('click', () => {
        if (navMain.classList.contains('nav-open')) {
            closeMainNav();
        } else {
            openMainNav();
        }
    });

    if (mainContent) {
        mainContent.addEventListener('click', () => {
            if (mainContent.classList.contains('nav-open')) {
                closeMainNav();
            }
        });
    }
}

if (navClose) {
    navClose.addEventListener('click', (event) => {
        event.preventDefault();
        closeMainNav();
    });
}